import { TFunction } from 'i18next'

import {
    FOLD_AND_AREA_WEIGHTED,
    NON_WEIGHTED,
    POSITION_WEIGHTED,
    SovWeight,
} from 'const/sovWeights'

interface SovWeightConfig {
    title: (t: TFunction) => string
    subtitle: (t: TFunction) => string
    metric: string
    pct_metric: string
}

export const SOV_WEIGHTS_MAP: Record<SovWeight, SovWeightConfig> = {
    [NON_WEIGHTED]: {
        title: (t) =>
            t('sov:timelineChart.equalWeighted.title', 'Equal Weighted'),
        subtitle: (t) =>
            t(
                'sov:timelineChart.equalWeighted.subtitle',
                'Every result is given the same weight regardless of position, size, or placement on the page.'
            ),
        metric: `${NON_WEIGHTED}`,
        pct_metric: `${NON_WEIGHTED}__pct`,
    },
    [POSITION_WEIGHTED]: {
        title: (t) =>
            t('sov:timelineChart.positionWeighted.title', 'Position Weighted'),
        subtitle: (t) =>
            t(
                'sov:timelineChart.positionWeighted.subtitle',
                'Results higher on the page receive greater weight, without considering result type or visual size.'
            ),
        metric: `${POSITION_WEIGHTED}__sum`,
        pct_metric: `${POSITION_WEIGHTED}__pct`,
    },
    [FOLD_AND_AREA_WEIGHTED]: {
        title: (t) =>
            t(
                'sov:timelineChart.visibilityWeighted.title',
                'Visibility Weighted'
            ),
        subtitle: (t) =>
            t(
                'sov:timelineChart.visibilityWeighted.subtitle',
                'Weights results by both page placement and visual size, giving more credit to prominent, full-width placements.'
            ),
        metric: `${FOLD_AND_AREA_WEIGHTED}__sum`,
        pct_metric: `${FOLD_AND_AREA_WEIGHTED}__pct`,
    },
}
